/* import __COLOCATED_TEMPLATE__ from './conversation-marked-as-spam.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationMarkedAsSpam from 'embercom/objects/inbox/renderable/conversation-marked-as-spam';

interface ConversationMarkedAsSpamPart extends RenderablePart {
  renderableData: ConversationMarkedAsSpam;
}

interface Args {
  part: ConversationMarkedAsSpamPart;
}

interface Signature {
  Args: Args;
}

export default class ConversationMarkedAsSpamComponent extends Component<Signature> {
  @service declare session: Session;

  get renderableData() {
    return this.args.part.renderableData;
  }

  get adminSummary() {
    return this.renderableData.adminSummary;
  }

  get isCurrentUser() {
    return this.adminSummary.id === this.session.teammate?.id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationMarkedAsSpam': typeof ConversationMarkedAsSpamComponent;
    'inbox2/conversation-stream/event-parts/conversation-marked-as-spam': typeof ConversationMarkedAsSpamComponent;
  }
}
